import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import Radio from './radio';

const FilterInput = ({ filters, onChange, width, name, stateRating }) => {
  const wrapperRef = useRef(null);
  const [showSelectBox, setShowSelectBox] = useState(false);
  const [selected, setSelected] = useState('');

  useEffect(() => {
    const [defaultFilter] = filters;
    setSelected(defaultFilter.name);
  }, []);

  useEffect(() => {
    if (stateRating) {
      setSelected(stateRating?.name);
    }
  }, [stateRating]);

  const onChangeField = (event, filteredItem) => {
    const filteredItemWithEventAction = { ...filteredItem, eventAction: 'Avaliações - Filtro' };
    const { value } = event.target;
    onChange(filteredItemWithEventAction);
    setSelected(value);
    toggleFilter();
  };

  const renderOptions = filters.map((filter, index) => (
    <Radio
      countReview={filter.countReview}
      key={filter.name}
      label={filter.name}
      name={name}
      selected={selected}
      onChange={e => onChangeField(e, filter)}
    />
  ));

  /* istanbul ignore next */
  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSelectBox(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
  }, [wrapperRef]);

  const toggleFilter = () => {
    setShowSelectBox(!showSelectBox);
  };

  return (
    <Wrapper ref={wrapperRef}>
      <Button onClick={toggleFilter} width={width} className={showSelectBox ? 'active' : ''}>
        {selected}
      </Button>
      <WrapperOptions display={showSelectBox ? 'block' : 'none'}>{renderOptions}</WrapperOptions>
    </Wrapper>
  );
};

export default FilterInput;

const Wrapper = styled.div`
  position: relative;
  margin-left: 15px;
`;

const WrapperOptions = styled.div`
  position: absolute;
  background: white;
  box-shadow: 0px 1px 35px 4px rgba(0, 0, 0, 0.15);
  width: 280px;
  right: 0;
  top: 60px;
  padding: 10px 20px;
  display: ${({ display }) => display};
  transition: all 0.5s ease-in-out;
  z-index: 10;
`;

const Button = styled.button`
  background: #fff;
  border: 1px solid #ccc;
  padding: 15px 35px 15px 20px;
  color: #666;
  font-size: 14px;
  position: relative;
  outline: none;
  width: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    border: solid #999;
    border-width: 0 2px 2px 0;
    right: 15px;
    top: calc(50% - 4px);
    transform: rotate(45deg);
    transition: transform 0.3s ease-in-out;
  }

  &.active {
    border: 1px solid #000;
    color: #000;

    &::after {
      transform: rotate(225deg);
      border-color: #000;
      top: calc(50% - 2px);
    }
  }
`;
